import React, { useState } from 'react';

import { Button, Table } from "react-bootstrap"

import JoinForms from './JoinForms';
import SelectColumns from './components/SelectColumns';
import Filters from './Filters';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import ResearchResults from "../../pages/research/results";

const Research = () => {
    // console.log("get dispatch details", useSelector(state => state));
    const [showResults, setShowResults] = useState(false)
    return (
        <div className="flex flex-col gap-10">
            <div className="recent-activities">
                <h3>Créer une requête</h3>
            </div>
            <JoinForms />
            <SelectColumns />
            <Filters />

            <Modal isOpen={showResults} toggle={() => setShowResults(false)} size="xl" centered className='large-model'>
                <ModalBody>
                    <ResearchResults />
                </ModalBody>
            </Modal>

            <div className="mt-4">
                {/* <Link to="/research/results"> */}
                <Button onClick={() => setShowResults(true)} variant="danger">Soumettre requête</Button>
                {/* </Link> */}
            </div>
        </div>
    );
}

export default Research;
